import { StrapiActions, StrapiActionTypes, StrapiState } from '../types/types';

const initialState: StrapiState = {};

export const gop = (state = initialState, action: StrapiActions): StrapiState => {
  switch (action.type) {
    case StrapiActionTypes.FETCH_REQUEST: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: state[modelName]?.data || [],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.FETCH_SUCCESS: {
      const { modelName, data, pagination } = action.payload;
      return {
        ...state,
        [modelName]: {
          data,
          loading: false,
          error: null,
          lastAddedId: state[modelName]?.lastAddedId,
          lastDocId: state[modelName]?.lastDocId,
          pagination,
        },
      };
    }

    case StrapiActionTypes.FETCH_FAILURE: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: state[modelName]?.data || [],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.ADD_REQUEST: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.ADD_SUCCESS: {
      const { modelName, data } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: [...(state[modelName]?.data || []), data],
          loading: false,
          error: null,
          lastAddedId: data.id,
          lastDocId: data.documentId,
        },
      };
    }

    case StrapiActionTypes.SET_LAST_DOC_ID: {
      const { modelName, documentId } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          lastDocId: documentId,
        },
      };
    }

    case StrapiActionTypes.SET_LAST_ADDED_ID: {
      const { modelName, id } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          lastAddedId: id,
        },
      };
    }

    case StrapiActionTypes.ADD_FAILURE: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.DELETE_REQUEST: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.DELETE_SUCCESS: {
      const { modelName, id } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          data: (state[modelName]?.data || []).filter((item) => item.documentId !== id),
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.DELETE_FAILURE: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.UPLOAD_FILE_REQUEST: {
      return {
        ...state,
        'gop-uploads': {
          ...state['gop-uploads'],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.UPLOAD_FILE_SUCCESS: {
      return {
        ...state,
        'gop-uploads': {
          ...state['gop-uploads'],
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.UPLOAD_FILE_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        'gop-uploads': {
          ...state['gop-uploads'],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.UPDATE_REQUEST: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.UPDATE_SUCCESS: {
      const { modelName, data } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          data: (state[modelName]?.data || []).map((item) => (item.documentId === data.documentId ? data : item)),
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.UPDATE_FAILURE: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_REQUEST: {
      return {
        ...state,
        actionByContext: {
          data: [],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        actionByContext: {
          data,
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        actionByContext: {
          data: [],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.FETCH_COMMENT_BY_CONTEXT_REQUEST: {
      return {
        ...state,
        commentByContext: {
          data: [],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.FETCH_COMMENT_BY_CONTEXT_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        commentByContext: {
          data,
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.FETCH_COMMENT_BY_CONTEXT_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        commentByContext: {
          data: [],
          loading: false,
          error,
        },
      };
    }

    case 'CLEAR_MODEL_DATA':
      return {
        ...state,
        [action.payload.modelName]: {
          data: [],
          loading: false,
          error: null,
          // другие поля если есть
        },
      };

    default:
      return state;
  }
};
